
import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
    map,
    Observable,
    Subject,
    switchMap,
    tap
} from "rxjs";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ApiClientService } from "~app/common/services/api-client.service";
import { KundListItem, SearchKundResponseDto } from "../../../virkeskop/models/skogsvard/kund-models";

type SearchKundForm = FormGroup<{
    text: FormControl<string>;
    adress: FormControl<string>;
    kundnummer: FormControl<string>;
    telefonnummer: FormControl<string>;
}>;
type SearchKundQuery = {
    text?: string;
    adress?: string;
    telefonnummer?: string;
    kundnummer?: string;
};

@Component({
    selector: "rask-avtal-kund-search-modal",
    imports: [RaskCommonModule],
    templateUrl: "./avtal-kund-search-modal.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./avtal-kund-search-modal.component.scss"
})
export class AvtalKundSearchModalComponent implements OnInit {
    protected form: SearchKundForm;
    protected kunder$: Observable<KundListItem[]>;
    protected  loading = false;
    private readonly fb = inject(FormBuilder);
    private readonly apiClientService = inject(ApiClientService);
    private readonly modal = inject(NgbActiveModal);
    private readonly searchSrc = new Subject<void>();

    ngOnInit(): void {
        this.form = this.fb.group({
            text: this.fb.control(""),
            adress: this.fb.control(""),
            kundnummer: this.fb.control(""),
            telefonnummer: this.fb.control("")
        });

        this.kunder$ = this.searchSrc.pipe(
            tap(() => this.loading = true),
            switchMap(() => this.search()),
            map(kunder => kunder.map(k => new KundListItem(k))),
            tap(() => this.loading = false)
        );
    }

    protected searchClick() {
        this.searchSrc.next();
    }

    protected addClick(kund: KundListItem) {
        this.modal.close(kund);
    }

    protected dismissClick() {
        this.modal.dismiss();
    }

    private search(): Observable<SearchKundResponseDto[]> {
        return this.apiClientService.post<SearchKundQuery, SearchKundResponseDto[]>("virkeskop/kund/search", {
            ...this.form.value
        });
    }
}
